import React from 'react';
import Modal from 'components/Modal';

export default function ForgotPasswordModal({ isOpen, onClose }) {
    return (
        <Modal open={isOpen} onClose={onClose} maxWidth="max-w-md" className="!w-full">
            <div className="flex flex-col items-center gap-0">
                <h2 className="w-full px-6 py-5 text-left font-display text-3xl font-black leading-tight text-white sm:text-4xl">
                    Elfelejtetted a jelszavad?
                </h2>

                <div className="w-full rounded-2xl bg-white p-6 text-neutral-900 shadow-2xl">
                    <p className="mb-6 text-sm leading-relaxed text-neutral-700">
                        Add meg a fiókodhoz tartozó e-mail címed, és küldünk neked egy új jelszót!
                        Jelszavadat belépés után bármikor módosíthatod.
                    </p>

                    <form className="flex flex-col gap-4" onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="email"
                            placeholder="E-mail cím"
                            className="w-full rounded-lg border border-gray-300 px-4 py-3.5 text-sm text-neutral-900 outline-none transition focus:border-green-400 focus:ring-4 focus:ring-green-100"
                            autoFocus
                            required
                        />
                        <button
                            type="submit"
                            className="gradient-green w-full rounded-lg p-3.5 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:brightness-110 hover:shadow-xl"
                        >
                            Küldjétek az új jelszavamat!
                        </button>
                    </form>

                    <p className="mt-6 text-xs leading-relaxed text-neutral-600 md:text-sm">
                        Nem emlékszel, milyen e-mail címmel regisztráltál? Vedd fel a hozzád legközelebb eső irodánkkal a kapcsolatot; kollégáink adategyeztetés után segítenek.
                    </p>

                    <button 
                        type="button"
                        className="gradient-yellow mt-4 w-full rounded-lg p-3.5 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:brightness-110 hover:shadow-xl"
                        onClick={() =>
                            window.open(
                                '/kapcsolat',
                                '_self'
                            )
                        }
                    >
                        Irodalistánkat itt éred el!
                    </button>
                </div>
            </div>
        </Modal>
    );
}
